<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">3</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h3 v-html="model.Step5aTitle"></h3>
                <p class="qualifier-tool-subheader-alt ">{{model.Step5aSubTitle}}</p>
            </div>
        </div>
        <!-- Options -->
        <div class="row qualifier-tool-form-row justify-content-between">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aAssistedLivingTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="AssistedLiving_yes" name="AssistedLiving" v-model="assistedLiving" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="AssistedLiving_yes" tabindex="0" v-on:keypress.enter="assistedLiving = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="AssistedLiving_no" name="AssistedLiving" v-model="assistedLiving" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="AssistedLiving_no" tabindex="0" v-on:keypress.enter="assistedLiving = false">{{model.NegativeResponseButtonText}}</label>
            </div>            
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aPastSixMonthsTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="PastSixMonths_yes" name="PastSixMonths" v-model="pastSixMonths" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="PastSixMonths_yes" tabindex="0" v-on:keypress.enter="pastSixMonths = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="PastSixMonths_no" name="PastSixMonths" v-model="pastSixMonths" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="PastSixMonths_no" tabindex="0" v-on:keypress.enter="pastSixMonths = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aMedicaidRecipientTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="MedicaidRecipient_yes" name="MedicaidRecipient" v-model="medicaidRecipient" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="MedicaidRecipient_yes" tabindex="0" v-on:keypress.enter="medicaidRecipient = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="MedicaidRecipient_no" name="MedicaidRecipient" v-model="medicaidRecipient" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="MedicaidRecipient_no" tabindex="0" v-on:keypress.enter="medicaidRecipient = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aNeedAssistanceTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="NeedsAssistance_yes" name="NeedsAssistance" v-model="needsAssistance" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="NeedsAssistance_yes" tabindex="0" v-on:keypress.enter="needsAssistance = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="NeedsAssistance_no" name="NeedsAssistance" v-model="needsAssistance" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="NeedsAssistance_no" tabindex="0" v-on:keypress.enter="needsAssistance = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aNeedTransportationTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="NeedsTransportation_yes" name="NeedsTransportation" v-model="needsTransportation" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="NeedsTransportation_yes" tabindex="0" v-on:keypress.enter="needsTransportation = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="NeedsTransportation_no" name="NeedsTransportation" v-model="needsTransportation" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="NeedsTransportation_no" tabindex="0" v-on:keypress.enter="needsTransportation = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aMedicareRecipientTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="MedicareRecipient_yes" name="MedicareRecipient"  v-model="medicareRecipient" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="MedicareRecipient_yes" tabindex="0" v-on:keypress.enter="medicareRecipient = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="MedicareRecipient_no" name="MedicareRecipient" v-model="medicareRecipient" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="MedicareRecipient_no" tabindex="0" v-on:keypress.enter="medicareRecipient = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <div class="row qualifier-tool-form-row">
            <div class="qualifier-tool-form-content">
                <p>{{model.Step5aVeteranTitle}}</p>
            </div>
            <div class="qualifier-tool-form-container">
                <input type="radio" id="Veteran_yes" name="Veteran" v-model="veteran" v-bind:value="true" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="Veteran_yes" tabindex="0" v-on:keypress.enter="veteran = true">{{model.PositiveResponseButtonText}}</label>
                <input type="radio" id="Veteran_no" name="Veteran" v-model="veteran" v-bind:value="false" required class="qualifier-tool-form-radio">
                <label class="qualifier-tool-form-radio-label" for="Veteran_no" tabindex="0" v-on:keypress.enter="veteran = false">{{model.NegativeResponseButtonText}}</label>
            </div>
        </div>
        <!-- Aditional information -->
        <div class="row">
            <div class="col-12">
                <p class="qualifier-tool-aditional-btn" tabindex="0" :class="{'qualifier-tool-aditional-btn-active': isAditionalInfo}" @click="isAditionalInfo = true" v-on:keypress.enter="isAditionalInfo = true">{{model.Step5aAdditionalInfoToggleTitle}}</p>
            </div>
        </div>
        <div class="row" v-if="isAditionalInfo">
            <div class="col-12">
                <textarea class="qualifier-tool-aditional-textarea" tabindex="0" v-bind:placeholder="model.Step5aAdditionalInfoTogglePlaceholder" v-model="aditionalInfo" ></textarea>
                <p class="qualifier-tool-aditional-subtitle">{{model.Step5aAdditionalInfoTitle}}</p>
            </div>
        </div>
        <!-- Submit section -->
        <div class="row d-flex justify-content-center qualifier-tool-footer">
            <button type="button" class="qualifier-tool-btn" @click="nextStepValidation()" v-bind:disabled="disableSubmit" tabindex="0">{{model.SubmitButtonText}}</button>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
                assistedLiving: "",
                pastSixMonths: "",
                medicaidRecipient: "",
                needsAssistance: "",
                needsTransportation: "",
                medicareRecipient: "",
                veteran: "",
                aditionalInfo: "",
                isAditionalInfo: false,
                disableSubmit: false,
                CampaingId: this.model.CampaingId,
                unsubscribe: null
			}
		},
		computed: mapState({
            concurrentGuid: state => state.WebQualifierTool.concurrentGuid,
            concurrentPostalCode: state => state.WebQualifierTool.concurrentPostalCode,
            formData: state => state.WebQualifierTool.formData,
		}),
		components: {
		},
		mounted: function () {	
            let _this = this;
            
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'WebQualifierTool/setQTResponse') {
                    _this.updateStep(12);      
                    _this.disableSubmit = false;         
				}
                if (mutation.type === 'WebQualifierTool/setQTErrorResponse') {
                    _this.disableSubmit = false;
                }
			});		
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step5A'});    
            }
		},
        beforeDestroy: function () {
            if (this.unsubscribe) {
                this.unsubscribe();
            }
        },
		methods: {
            ...mapActions('WebQualifierTool', { updateStep: 'updateStep' }),
            ...mapActions('WebQualifierTool', { postData: 'postData' }),
            ...mapMutations('WebQualifierTool', { setLoadingState: 'setLoadingState' }),
            nextStepValidation() {
                this.postPersonalInfo();
            },
            postPersonalInfo() {
                let data = {
                    "SubmitToWebService": true,
                    "GetCallUsText": true,
                    "SubmittedQualifierToolGuid": this.concurrentGuid,
                    "QualifierToolToSubmitModel": {
                        "ivg_campaignidtext" : this.CampaingId,
                        "AssistedLiving": this.assistedLiving,
                        "PastSixMonths": this.pastSixMonths,
                        "MedicaidRecipient": this.medicaidRecipient,
                        "NeedsAssistance": this.needsAssistance,
                        "NeedsTransportation": this.needsTransportation,
                        "MedicareRecipient": this.medicareRecipient,
                        "Veteran": this.veteran,
                        "Comments": this.aditionalInfo,
                        "PostalCode": this.concurrentPostalCode,
                        "ReferringUTMQueryString": this.formData.utmData,
                        "FormStep": "step5a",
                    }
                }
                this.disableSubmit = true;
                this.setLoadingState(true);
                this.postData(data);
                if (window.dataLayer != null) {
                    window.dataLayer.push({'event': 'Step5A.FormSubmission'});    
                }
            }
        },
    }
</script>
